import { faCommentDots } from "@fortawesome/pro-regular-svg-icons";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import truncate from "lodash-es/truncate";
import React, { useState } from "react";

import { postDetailUrl } from "@/mk2/apps/forum/helpers";
import { PostEntity } from "@/mk2/apps/forum/schemas";
import { Link } from "@/mk2/components/Link";
import { Panel } from "@/mk2/components/Panel";
import { TrackClick } from "@/mk2/components/TrackClick";
import { FORUM_SHOW_MORE_DISCUSSIONS } from "@/mk/autogenerated/translation";
import { upperCaseFirst } from "@/mk/bazaar/common/filters";

import styles from "./PostDetailRelatedV2.mscss";

interface PostDetailRelatedV2Props {
    posts: PostEntity[];
}

const PostDetailRelatedV2: React.FunctionComponent<PostDetailRelatedV2Props> = ({ posts }) => {
    const [expanded, setExpanded] = useState(false);

    if (posts.length === 0) {
        return null;
    }

    const firstPost = posts[0];
    const secondaryPosts = posts.slice(1);

    return (
        <Panel className={styles.PostDetailRelatedV2}>
            <ul className={styles.PostDetailRelatedV2__list}>
                <li key={firstPost.id} className={styles.PostDetailRelatedV2__item}>
                    <TrackClick
                        name="forum_related_v2_click"
                        props={{ post_id: firstPost.id, post_slug: firstPost.slug, variant: "new" }}
                    >
                        <Link to={postDetailUrl(firstPost)}>
                            {upperCaseFirst(truncate(firstPost.heading, { length: 80 }))}
                        </Link>
                    </TrackClick>
                    <span className={styles.PostDetailRelatedV2__comments}>
                        <FontAwesomeIcon icon={faCommentDots} /> {firstPost.comments}
                    </span>
                </li>
                {expanded &&
                    secondaryPosts.map((post) => (
                        <li key={post.id} className={styles.PostDetailRelatedV2__item}>
                            <TrackClick
                                name="forum_related_v2_click"
                                props={{ post_id: post.id, post_slug: post.slug, variant: "new" }}
                            >
                                <Link to={postDetailUrl(post)}>
                                    {upperCaseFirst(truncate(post.heading, { length: 80 }))}
                                </Link>
                            </TrackClick>
                            <span className={styles.PostDetailRelatedV2__comments}>
                                <FontAwesomeIcon icon={faCommentDots} /> {post.comments}
                            </span>
                        </li>
                    ))}
            </ul>
            <button
                className={styles.PostDetailRelatedV2__expandBtn}
                onClick={() => setExpanded(!expanded)}
                type="button"
            >
                {FORUM_SHOW_MORE_DISCUSSIONS}{" "}
                <FontAwesomeIcon icon={expanded ? faChevronUp : faChevronDown} />
            </button>
        </Panel>
    );
};

PostDetailRelatedV2.displayName = "PostDetailRelatedV2";

export { PostDetailRelatedV2 };
